const studentProgramme = {
    state: {
      unitId: null,
      programId: null,
      units: null,
      currentGradeId: null,
    },
    mutations: {
      setUnitId(state,unitId){
        state.unitId = unitId
      },
      setProgramId(state,programId){
        state.programId = programId
      },
      setUnits(state,units){
        state.units = units
      },
      setGradeId(state,gradeId){
        state.currentGradeId = gradeId
      },
    },
    actions: {
      setUnitId(context,unitId){
        context.commit('setUnitId', unitId)
      },
      setProgramId(context,programId){
        context.commit('setProgramId', programId)
      },
      setUnits(context,units){
        context.commit('setUnits', units)
      },
      setGradeId(context,gradeId){
        context.commit('setGradeId', gradeId)
      },
    }
}

export default studentProgramme